import { Controller } from "@hotwired/stimulus"
import { internationalPhone } from "../../src/shared/helpers/international_phone"

// Flag picker of Ui::Form::PhoneFieldComponent. The input keeps what is typed;
// a national number is sent with the picked country's prefix, so the server
// (which defaults to France) stores "+32 470 12 34 56", not "+33 4 70…".
export default class extends Controller {
  static targets = ["select", "flag", "input"]

  connect () {
    this.refresh()
    this.form = this.inputTarget.form
    this.onFormData = ({ formData }) => {
      const name = this.inputTarget.name
      if (formData.has(name)) formData.set(name, internationalPhone(this.inputTarget.value, this.dialCode))
    }
    this.form?.addEventListener("formdata", this.onFormData)
  }

  disconnect () {
    this.form?.removeEventListener("formdata", this.onFormData)
  }

  change () {
    const previousDialCode = this.inputTarget.dataset.phoneDialCode
    this.refresh()
    this.inputTarget.value = swapPrefix(this.inputTarget.value, previousDialCode, this.dialCode)
  }

  // "+32…" typed by hand picks Belgium.
  detect () {
    const phone = this.inputTarget.value.trim().replace(/^00/, "+")
    if (!phone.startsWith("+")) return

    const digits = phone.replace(/\D/g, "")
    const option = this.optionsByLongestPrefix.find(({ dataset }) => digits.startsWith(dataset.dialCode))
    if (!option || option.value === this.selectTarget.value) return

    this.selectTarget.value = option.value
    this.refresh()
  }

  refresh () {
    const option = this.selectedOption
    this.flagTarget.textContent = option.dataset.flag
    this.inputTarget.dataset.phoneCountry = option.value
    this.inputTarget.dataset.phoneDialCode = option.dataset.dialCode
  }

  get optionsByLongestPrefix () {
    // Longest prefix first: "+352" is Luxembourg, not "+35…".
    return Array.from(this.selectTarget.options).sort((a, b) => b.dataset.dialCode.length - a.dataset.dialCode.length)
  }

  get selectedOption () {
    return this.selectTarget.options[this.selectTarget.selectedIndex]
  }

  get dialCode () {
    return this.selectedOption.dataset.dialCode
  }
}

function swapPrefix (value, previousDialCode, dialCode) {
  const prefix = `+${previousDialCode}`
  if (!previousDialCode || !value.trim().startsWith(prefix)) return value

  return value.trim().replace(prefix, `+${dialCode}`)
}
